import { IHorsePowerRate } from '../../interfaces/ihorse-power-rate';
import { UnitOfMeasure } from '../unit-of-measure';

export class HorsePowerRateBase {
  HorsePowerRateId: number;
  MinPressure: number;
  MaxPressure: number;
  UnitRate: number;
  UnitOfMeasureId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IHorsePowerRate) {
    if (item) {

      this.HorsePowerRateId = item.HorsePowerRateId;
      this.MinPressure = item.MinPressure;
      this.MaxPressure = item.MaxPressure;
      this.UnitRate = item.UnitRate;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}